import { UPDATE_EVENT_DARE } from 'root/src/client/logic/dropEvent/actionIds'

export default payload => ({
	type: UPDATE_EVENT_DARE,
	payload,
})
